import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu, X } from "lucide-react";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

const NAV = [
  { to: "/", key: "nav.home", testId: "nav-home" },
  { to: "/teknoloji", key: "nav.technology", testId: "nav-technology" },
  { to: "/donanim", key: "nav.hardware", testId: "nav-hardware" },
  { to: "/cozumler", key: "nav.solutions", testId: "nav-solutions" },
  { to: "/neden-biz", key: "nav.whyus", testId: "nav-whyus" },
  { to: "/iletisim", key: "nav.contact", testId: "nav-contact" },
];

export const Navbar = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 backdrop-blur-xl bg-[#f8faf9]/80 border-b border-[#1a3636]/5">
      <nav className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-logo"
          className="font-display font-extrabold tracking-tight text-[#1a3636] text-lg md:text-xl leading-none"
        >
          PERGAMON<span className="text-[#2b8a7e]"> BIO</span> SYSTEMS
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testId}
              className={({ isActive }) =>
                `relative text-sm font-medium tracking-wide transition-colors duration-300 ${
                  isActive ? "text-[#2b8a7e]" : "text-[#1a3636]/70 hover:text-[#1a3636]"
                }`
              }
            >
              {({ isActive }) => (
                <span className="inline-flex flex-col">
                  {t(item.key)}
                  <span
                    className={`mt-1 h-[2px] rounded-full bg-[#2b8a7e] transition-all duration-300 ${
                      isActive ? "w-full" : "w-0"
                    }`}
                  />
                </span>
              )}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden rounded-full border border-[#1a3636]/15 p-2 text-[#1a3636]"
          >
            {open ? <X size={18} strokeWidth={1.5} /> : <Menu size={18} strokeWidth={1.5} />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-[#1a3636]/5 bg-[#f8faf9] px-6 py-4">
          <div className="flex flex-col gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`${item.testId}-mobile`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-lg px-4 py-3 text-base font-medium transition-colors ${
                    isActive ? "bg-[#2b8a7e]/10 text-[#2b8a7e]" : "text-[#1a3636]/80"
                  }`
                }
              >
                {t(item.key)}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
